import { render, staticRenderFns } from "./permissions-routes-check.vue?vue&type=template&id=9784170c&"
import script from "./permissions-routes-check.vue?vue&type=script&lang=js&"
export * from "./permissions-routes-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports